export const fontList = [
    "Josefin Sans",
    "Bebas Neue",
    "Space Grotesk",
    "Exo 2",
    "Chakra Petch",
    "Saira",
    "Fugaz One",
    "Staatliches"
];